// extracted by css-extract-rspack-plugin
export default {"locker__container":"withLocker_locker__container__lpTZd","locker__icon":"withLocker_locker__icon__KAxqW"};